module.exports = __webpack_public_path__ + "static/media/aspen.8f180041.png";